import {
  HIVE_FRAME_TITLE_WIDGET,
  HiveFrameTitleWidget,
} from './hive-frame-title-widget.js';
import { EdgelessFrameTitleEditor } from './edgeless-frame-title-editor.js';
import { HIVE_FRAME_TITLE, HiveFrameTitle } from './frame-title.js';

export function effects() {
  customElements.define(HIVE_FRAME_TITLE_WIDGET, HiveFrameTitleWidget);
  customElements.define(HIVE_FRAME_TITLE, HiveFrameTitle);
  customElements.define(
    'edgeless-frame-title-editor',
    EdgelessFrameTitleEditor
  );
}
